import { useState } from "react";
import { Menu, X } from "lucide-react";
import { EXPERIENCES, HOME_URL } from "../../config/lumacofono";

const LOGO = "/brand/lumacofono-logo-128.jpg";

const NavLink = ({ item, mobile }) => (
  <a
    href={item.href}
    aria-current={item.current ? "page" : undefined}
    data-testid={`nav-${mobile ? "m-" : ""}${item.id}`}
    className={
      mobile
        ? `block rounded-[14px] px-4 py-3 ${item.current ? "bg-[#F5EEFF]" : "hover:bg-[#F7FBFF]"}`
        : `text-[14px] font-semibold transition-colors ${item.current ? "text-[#7433C1]" : "text-[#506780] hover:text-[#14233D]"}`
    }
  >
    {mobile ? (
      <>
        <span className={`block text-[16px] font-bold ${item.current ? "text-[#7433C1]" : "text-[#14233D]"}`}>{item.label}</span>
        <span className="block text-[13px] text-[#506780]">{item.hint}</span>
      </>
    ) : (
      item.label
    )}
  </a>
);

export const SiteHeader = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="relative z-30 bg-white border-b border-[#D0E4F3]" data-testid="site-header">
      <div className="max-w-6xl mx-auto px-4 min-h-[76px] flex items-center justify-between gap-4">
        <a href={HOME_URL} className="flex items-center gap-3 text-[#14233D]" data-testid="site-brand">
          <img src={LOGO} alt="Logo Lumacofono" width="54" height="54" className="w-[54px] h-[54px] object-contain" />
          <span className="luma-wordmark text-[22px]">Lumacofono</span>
        </a>
        <nav className="hidden md:flex items-center gap-6" aria-label="Esperienze Lumacofono">
          {EXPERIENCES.map((item) => <NavLink key={item.id} item={item} />)}
        </nav>
        <button
          type="button"
          className="md:hidden w-11 h-11 rounded-[12px] border border-[#D0E4F3] flex items-center justify-center text-[#14233D]"
          aria-label={open ? "Chiudi il menu" : "Apri il menu"}
          aria-expanded={open}
          onClick={() => setOpen(!open)}
          data-testid="site-menu-button"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <nav className="md:hidden absolute inset-x-0 top-full bg-white border-b border-[#D0E4F3] px-3 py-3 shadow-[0_12px_24px_-12px_rgba(20,35,61,0.25)]" aria-label="Esperienze Lumacofono" data-testid="site-menu">
          {EXPERIENCES.map((item) => <NavLink key={item.id} item={item} mobile />)}
        </nav>
      )}
    </header>
  );
};
